export default "__VITE_ASSET__DGBuZVwz__"